export const scanFillLocales = {
  en: {
    scanFill: {
      title: "Scan document",
      hint: "Photograph the paper document with your phone camera or choose an image. Fields are filled from its text and the scan is attached to the record.",
      camera: "Scan with camera",
      library: "Choose image or PDF",
      loadingModel: "Preparing text recognition…",
      reading: "Reading the document…",
      readingPage: "Reading page {{n}} of {{total}}…",
      filled: "{{count}} fields were filled from the document. Check them before saving.",
      nothingFound: "No matching fields were found. The scan will still be attached when you save.",
      noText: "No text could be read. Try a sharper photo in better light; the scan will still be attached.",
      pdfAttached: "The PDF will be attached when you save. Text is read from photos and images only.",
      attached: "Scan ready to attach ({{pages}} pages)",
      attachedPdf: "PDF ready to attach: {{name}}",
      remove: "Remove scan",
      showText: "Show the text that was read",
      hideText: "Hide text",
      uploadFailed: "The record was saved but the scan could not be uploaded. {{error}}",
      privacy: "Text is read in your browser; nothing is sent to an outside service.",
      error: "The document could not be processed. {{error}}"
    }
  },
  tr: {
    scanFill: {
      title: "Belge tara",
      hint: "Kâğıt belgeyi telefon kamerasıyla çekin ya da bir görsel seçin. Alanlar belgedeki metinden doldurulur ve tarama kayda eklenir.",
      camera: "Kamerayla tara",
      library: "Görsel veya PDF seç",
      loadingModel: "Metin tanıma hazırlanıyor…",
      reading: "Belge okunuyor…",
      readingPage: "Sayfa {{n}} / {{total}} okunuyor…",
      filled: "Belgeden {{count}} alan dolduruldu. Kaydetmeden önce kontrol edin.",
      nothingFound: "Eşleşen alan bulunamadı. Kaydettiğinizde tarama yine de kayda eklenir.",
      noText: "Metin okunamadı. Daha net ve iyi ışıkta bir fotoğraf deneyin; tarama yine de kayda eklenir.",
      pdfAttached: "PDF kaydettiğinizde eklenecek. Metin yalnızca fotoğraf ve görsellerden okunur.",
      attached: "Tarama eklenmeye hazır ({{pages}} sayfa)",
      attachedPdf: "PDF eklenmeye hazır: {{name}}",
      remove: "Taramayı kaldır",
      showText: "Okunan metni göster",
      hideText: "Metni gizle",
      uploadFailed: "Kayıt kaydedildi ancak tarama yüklenemedi. {{error}}",
      privacy: "Metin tarayıcınızda okunur; dış bir servise gönderilmez.",
      error: "Belge işlenemedi. {{error}}"
    }
  },
  ar: {
    scanFill: {
      title: "مسح مستند",
      hint: "صوّر المستند الورقي بكاميرا الهاتف أو اختر صورة. تُملأ الحقول من نصه ويُرفق المسح بالسجل.",
      camera: "المسح بالكاميرا",
      library: "اختيار صورة أو PDF",
      loadingModel: "جارٍ تجهيز التعرف على النص…",
      reading: "جارٍ قراءة المستند…",
      readingPage: "جارٍ قراءة الصفحة {{n}} من {{total}}…",
      filled: "تم ملء {{count}} حقول من المستند. راجعها قبل الحفظ.",
      nothingFound: "لم يتم العثور على حقول مطابقة. سيُرفق المسح عند الحفظ.",
      noText: "تعذرت قراءة النص. جرّب صورة أوضح في إضاءة أفضل؛ سيُرفق المسح على أي حال.",
      pdfAttached: "سيُرفق ملف PDF عند الحفظ. يُقرأ النص من الصور فقط.",
      attached: "المسح جاهز للإرفاق ({{pages}} صفحات)",
      attachedPdf: "ملف PDF جاهز للإرفاق: {{name}}",
      remove: "إزالة المسح",
      showText: "عرض النص المقروء",
      hideText: "إخفاء النص",
      uploadFailed: "تم حفظ السجل لكن تعذر رفع المسح. {{error}}",
      privacy: "تتم قراءة النص في متصفحك ولا يُرسل إلى أي خدمة خارجية.",
      error: "تعذرت معالجة المستند. {{error}}"
    }
  }
};
